import types from './Types';

// Action Creators

export const logStoreSearchEvent = (action, label) => ({
    type: types.STORE_SEARCH,
    action: action,
    label: label
});

export const logAvailability = data => ({
    type: types.AVAILABILITY,
    data: data
});
